import React from "react";

const Caret = (props) => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      xmlns="http://www.w3.org/2000/svg"
      className="caret"
    >
      <path d="M0.412893 1.86173L4.01989 4.68155C4.56303 5.10615 5.44041 5.10615 5.98354 4.68155L9.59054 1.86173C10.4679 1.17583 9.84122 0 8.60175 0H1.38776C0.148287 0 -0.464485 1.17583 0.412893 1.86173Z" />
    </svg>
  );
};

export default Caret;
